import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchGetArenas } from "./asyncActions";

import { ICourtRentState, ISelctedSeat, ISelctedRacket } from "./types";

const initialState: ICourtRentState = {
  date: "",
  arenas: [],
  rackets: [],
  selectedSeats: {},
  selectedRackets: {},
  isLoading: false,
  arenasName: [], // Названия типов кортов для ChoosingRoom
  loadedDate: "", // Дата, для которой загружены данные
  loadedDates: {}, // Дата и время загрузки
  isBackgroundLoading: false, // Флаг фоновой загрузки
};

const rentSlice = createSlice({
  name: "rent",
  initialState,
  reducers: {
    setDate(state, action: PayloadAction<string>) {
      state.date = action.payload;
    },
    setSelctedSeats(state, action: PayloadAction<{ [key: string]: ISelctedSeat }>) {
      state.selectedSeats = action.payload;
    },
    setSelctedRackets(state, action: PayloadAction<{ [key: string]: ISelctedRacket }>) {
      state.selectedRackets = action.payload;
    },
    resetSelectedSeats(state) {
      state.selectedSeats = {};
    },
    resetSelectedRackets(state) {
      state.selectedRackets = {};
    },
  },
  extraReducers: (builder) => {
    // get courts
    builder.addCase(fetchGetArenas.pending, (state, action) => {
      // Проверяем, есть ли уже данные для этой даты
      const requestedDate = (action.meta.arg as { date: string }).date;
      const hasDataForDate = state.loadedDate === requestedDate && state.arenas.length > 0;
      
      // Проверяем, загружены ли данные сегодня (сравниваем даты без времени)
      const today = new Date().setHours(0, 0, 0, 0);
      const loadedTimestamp = state.loadedDates[requestedDate];
      const loadedToday = loadedTimestamp && 
        today === new Date(loadedTimestamp).setHours(0, 0, 0, 0);
      
      // Если данные уже есть для этой даты и загружены сегодня - загружаем фоном
      if (hasDataForDate && loadedToday) {
        state.isBackgroundLoading = true;
      } else {
      state.isLoading = true;
        state.isBackgroundLoading = false;
      }
    });
    builder.addCase(
      fetchGetArenas.fulfilled,
      (state, action) => {
        const requestedDate = (action.meta.arg as { date: string }).date;
        state.arenas = action.payload;
        // Сохраняем уникальные названия типов кортов
        state.arenasName = action.payload.map(arena => arena.title);
        state.loadedDate = requestedDate;
        state.loadedDates[requestedDate] = Date.now();
        state.isLoading = false;
        state.isBackgroundLoading = false;
      }
    );
    builder.addCase(fetchGetArenas.rejected, (state) => {
      state.isLoading = false;
      state.isBackgroundLoading = false;
    });
  },
});

export const {
  setDate,
  setSelctedSeats,
  setSelctedRackets,
  resetSelectedSeats,
  resetSelectedRackets,
} = rentSlice.actions;

export default rentSlice.reducer;
